//@ts-nocheck - window.gtag events are not typed
const pintrestEvents = {
    pagevisit: () => window.pintrk?.('track', 'pagevisit'),
    signup: () => window.pintrk?.('track', 'signup'),
    lead: () => window.pintrk?.('track', 'lead'), // Start Trial
};

export default pintrestEvents;
